import { Component, OnInit, TemplateRef, ViewChild, NgZone, Input } from '@angular/core';
import { Router } from '@angular/router';
import { createReactTemplateElement } from '@angular-react/core';
import { CurrencyPipe } from '@angular/common';
import { CellType } from '@amobee/component-library';
import { PlanStatus } from '../../../planner-edit/constants/PlanStatus.const';
import { TableConfigs, ToolBarConfigs } from '../../../../../common/components/data-table/data-table.component';
import { ModalService } from '../../../../../services/modal.service';
import { ListActionsService } from '../../../../services/list-actions.service';
import { PlannerEndpoints } from '../../../../constants/planner-endpoints.const';
import { find } from 'lodash';
import { FilterSetup } from '../../../../../common/components/data-table/list-filter/list-filter.component';
import { TimezonePipe } from '../../../../../common/pipes/timezone.pipe';
import * as moment from 'moment';

@Component({
  selector: 'planner-list',
  templateUrl: './planner-list.component.html',
  styleUrls: ['./planner-list.component.scss']
})
export class PlannerListComponent implements OnInit {

  @Input('advertiserInfo') public advertiserInfo: any;

  @ViewChild('statusTemplate', { static: true }) public statusTemplate: TemplateRef<any>;
  @ViewChild('labelTemplate', { static: true }) public labelTemplate: TemplateRef<any>;
  currentDate: any;

  constructor(
    public ngZone: NgZone,
    private router: Router,
    private modal: ModalService,
    private listActionService: ListActionsService,
    private timezonePipe: TimezonePipe,
    private currencyPipe: CurrencyPipe
  ) { }

  ngOnInit() {
    this.currentDate = moment().valueOf();
    let accountFilter: FilterSetup = find(this.toolbarConfigs.filterSetup, { name: 'createdBy' });
    if (accountFilter) {
      accountFilter.options = PlannerEndpoints.planAccount + '?marketId=' + this.advertiserInfo.marketId +
        '&advertiserId=' + this.advertiserInfo.id;
    }
    let labelFilter: FilterSetup = find(this.toolbarConfigs.filterSetup, { name: 'label' });
    if (labelFilter) {
      labelFilter.options = PlannerEndpoints.planLabel + '?advertiserId=' + this.advertiserInfo.id;
    }
  }
  updatedPlanStatus = () => {
    let planStatus = Object.assign({}, PlanStatus);
    delete planStatus.Submitted;
    return planStatus;
  }
  public reloadTableTriggered: any;
  public filterUpdates: any;
  public tableConfigs: TableConfigs = {
    disableSorting: false,
    defaultSort: {
      id: 'createdDate',
      desc: true
    },
    uniqueIdAccessor: 'planId',
    pageSize: 25, // default to 25
    isSelectionEnabled: true,
    isPaginationEnabled: true,
    showSummaryRow: false,
    stickyHeader: true,
    stickyColumnHeaders: true,
    enableStickyColumns: true,
    endpoint: PlannerEndpoints.planConfigList,
    showCallToAction: true,
    callToActionProps: {
      type: 'EmptyTable',
      title: 'No Plans Found'
    }
  };
  public columns: any[] = [
    {
      Header: 'Name',
      accessor: 'name',
      id: 'name',
      sticky: 'left',
      cellType: CellType.LINK,
      onLinkClick: row => {
        this.router.navigate(['planner-dashboard', row.original.planId]);
      },
      isActive: (row) => {
        return row.original.status === PlanStatus.PreviewReady.key || row.original.status === PlanStatus.Activated.key || row.original.status === PlanStatus.DspError.key || row.original.status === PlanStatus.Expired.key;
      },
      isRowActionColumn: true,
      rowActionButtons: [
        {
          buttonType: 'button',
          iconName: 'Edit',
          onClick: row => {
            this.router.navigate(['planner/edit', row.original.planId]);
          },
          titleText: 'Edit'
        },
        {
          buttonType: 'dropdown',
          //iconName: 'Overflow',
          items: [
            {
              label: 'Generate Plan',
              onClick: (props) => {
                this.modal.confirmation({ message: 'Are you sure you want to generate the selected plan?' },
                  () => {
                    let id: string = props.row.original.planId + '';
                    this.listActionService.listActionUpdate(PlannerEndpoints.planGenerate, [id], true).then(
                      // refresh table
                      () => this.reloadTableTriggered = {}
                    );
                  }
                )
              },
              isHidden: (row) => {
                return !(row.original.status === PlanStatus.Draft.key || row.original.status === PlanStatus.PaasError.key);
              }
            },
            {
              label: 'Activate Plan',
              onClick: (props) => {
                this.modal.confirmation({ message: 'Are you sure you want to activate the selected plan?' },
                  () => {
                    let id: string = props.row.original.planId + '';
                    this.listActionService.listActionUpdate(PlannerEndpoints.planActivate, [id], true).then(
                      // refresh table
                      () => this.reloadTableTriggered = {}
                    );
                  }
                )
              },
              isHidden: (row) => {
                //Disable activate plan option if plan status is not preview ready or dsp error or if it has past start date or end date.
                return !(row.original.status === PlanStatus.PreviewReady.key || row.original.status === PlanStatus.DspError.key) ||
                  (moment(row.original.startDate).valueOf() < this.currentDate || moment(row.original.endDate).valueOf() < this.currentDate);
              }
            },
            {
              label: 'Copy',
              onClick: (props) => {
                this.modal.confirmation({ message: 'Are you sure you want to copy the selected plan?' },
                  () => {
                    let id: string = props.row.original.planId + '';
                    this.listActionService.duplicate(id, this.advertiserInfo.id, this.advertiserInfo.marketId);
                  }
                )
              },
            },
            {
              label: 'Archive',
              onClick: (props) => {
                this.modal.confirmation({ message: 'Are you sure you want to archive the selected plan?' },
                  () => {
                    let id: string = props.row.original.planId + '';
                    this.listActionService.listActionUpdate(PlannerEndpoints.planArchive, [id], true).then(
                      // refresh table
                      () => this.reloadTableTriggered = {}
                    );
                  }
                )
              },
              isHidden: (row) => {
                return row.original.status === PlanStatus.Archived.key;
              }
            },
            {
              label: 'IO Dashboard',
              onClick: (props) => {
                let activation: any = props.row.original.activation;
                if (activation && activation.DigitalVideo) {
                  window.open(activation.DigitalVideo, '_blank');
                }

              },
              isHidden: (row) => {
                return !row.original.activation || row.original.status !== PlanStatus.Activated.key;
              }
            }
          ]
        }
      ]
    },
    {
      Header: 'Status',
      accessor: row => {
        // hide return icon property currently until we have icon defined for every plan status
        // return PlanStatus[row.status].icon;
        return PlanStatus[row.status] && PlanStatus[row.status].label || 'N/A';
      },
      id: 'status',
      disableSortBy: true
      /* hide cell property currently until we have icon defined for every plan status
      Cell: (props) => {
        return createReactTemplateElement(this.statusTemplate, props.cell, this.ngZone);
      }*/
    },
    {
      Header: 'Budget',
      accessor: row => {
        // figure out a way to print out currency
        if (row.spendingCap) {
          return this.currencyPipe.transform(row.spendingCap, row.currency, 'symbol', '1.2-10');
        } else {
          return '-'
        }
      },
      id: 'spendingCap',
      disableSortBy: true
    },
    {
      Header: 'Created By',
      accessor: 'createdBy',
      id: 'createdBy',
      disableSortBy: true
    },
    {
      Header: 'Start Date',
      accessor: row => {
        // might want to consider timezone in the future
        return this.timezonePipe.transform(row.startDate, undefined, row.marketTimeZone);
      },
      id: 'startDate',
      disableSortBy: true
    },
    {
      Header: 'End Date',
      accessor: row => {
        // might want to consider timezone in the future
        return this.timezonePipe.transform(row.endDate, undefined, row.marketTimeZone);
      },
      id: 'endDate',
      disableSortBy: true
    },
    {
      Header: 'Label',
      accessor: 'labels',
      id: 'labels',
      Cell: (props) => {
        return createReactTemplateElement(this.labelTemplate, props.cell, this.ngZone);
      },
      disableSortBy: true
    },
    {
      Header: 'ID',
      accessor: 'planId',
      id: 'planId',
      disableSortBy: true
    }
  ];

  public toolbarConfigs: ToolBarConfigs = {
    toolbarOptions: {
      isAddButtonVisible: true,
      isRefreshVisible: true,
      onAddClick: () => {
        this.router.navigate(['planner/new'], { queryParams: { advertiserId: this.advertiserInfo.id, marketId: this.advertiserInfo.marketId } });
      }
    },
    bulkOptions: {
      isBulkRemoveVisible: true,
      onBulkRemoveClickExec: (selectedRows: any[]) => {
        this.modal.confirmation({ message: 'Are you sure you want to archive the selected plans?' },
          () => {
            let idList: string[] = [];
            selectedRows.forEach((value) => {
              idList.push(value.original.planId + '');
            });
            this.listActionService.listActionUpdate(PlannerEndpoints.planArchive, idList, true).then(
              // refresh table
              () => this.reloadTableTriggered = {}
            );
          }
        );
      },
      // this is unused property but it is required for the interface
      hide: false
    },
    isSearchEnable: true,
    filterSetup: [
      {
        label: 'Plan Status',
        name: 'status',
        options: this.listActionService.getOptionsFromConst(this.planStatus, 'id', 'label'),
        initialValue: PlanStatus.Draft.id
      },
      {
        label: 'Created By',
        name: 'createdBy',
        options: PlannerEndpoints.planAccount,
        initialValue: -1
      },
      {
        label: 'Label',
        name: 'label',
        options: PlannerEndpoints.planLabel,
        initialValue: ""
      }
    ]
  }

  onLabelClick($event, label) {
    if (!this.filterUpdates || this.filterUpdates.label !== label) {
      this.filterUpdates = { 'label': label };
    }
  }
  onRowSelectionChange(selectedRows: Array<any>) {
    if (selectedRows.length) {
      let allArchived: boolean = selectedRows.every((row: any) => {
        return row.original.status == PlanStatus.Archived.key
      });
      this.toolbarConfigs.bulkOptions.isBulkRemoveDisabled = allArchived;
    }
  }

  get planStatus() {
    return this.updatedPlanStatus();
  }

}
